import React from 'react';
import styled, { keyframes } from 'styled-components';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { TransitionGroup } from 'react-transition-group';

import {
    onGoToNextActionInsideCard,
    onSubscribeComplete,
    setOverlayPartnerVisible,
    getApiRequestData
} from '../Widget/actions';

import {
    fetchVolunteerOpportunities,
    onSelectVolunteerOpportunity,
    onGoToStep,
    onShowLocationChangePopup,
    onDetailsContainerClick
} from './actions';

import NextAction from '../Widget/NextAction';
import Overlay from '../Widget/Overlay';
import OverlayPartner from '../Widget/OverlayPartner';
import OverlayPublisher from '../Widget/OverlayPublisher';
import WidgetHeader from '../Widget/WidgetHeader';

import { Title } from '../DefaultStyles/Shared';

import { LoadingSpinner } from '../../components/LoadingSpinner';
import { PBVMFooter, ChangeLocationLink } from '../../components/Volunteer/Shared';
import ShareDrawer from '../../components/ShareDrawer';
import MultiActionsCardAction from '../../components/MultiActionsCard/MultiActionsCardAction';
import Carousel from '../../components/Shared/Carousel';
import DefaultVolunteerImage from '../../components/Volunteer/DefaultImage';
import LocationChangePopup from '../../components/Volunteer/LocationChangePopup';
import VolunteerSubscribeForm from '../../components/Volunteer/VolunteerSubscribeForm';
import CssTransition from '../../components/Transition/CssTransition';

import { CardTypes } from '../../utils/enums';
import { widthEm, isPortrait } from '../../utils/size';
import { Placeholders } from '../../utils/fillDynamicText';
import {
    getNextAction,
    buildConditionalActionsAnswerHistory
} from '../../utils/nextActionUtil';
import { isLongText } from '../../components/Shared/commonFunctions';
import {
    normalizeOpportunityName,
    replaceLocale,
    truncateOpportunityDescription,
    truncateOpportunityTitle,
    truncateTitle
} from '../../utils/volunteer/helpers';
import { cacheFormData } from '../../utils/formCaching/actions';

import { Container, Body } from '../DefaultStyles/Details';
import { Footer } from '../DefaultStyles/Shared';
import { ParentOrg } from '../../components/Volunteer/Shared';

import volunteerMatchLogo from '../../assets/images/volunteermatch.png';

const ShrinkCardWrapper = (from, to) => keyframes`
    from {
        height: ${from}px;
    }
    to {
        height: ${to}px;
    }
`;

const VolunteerBody = styled(Body)`
    flex: 1;
`;

const VolunteerCardWrapper = styled.div`
    background-color: ${props =>
        props.backgroundColor ? props.backgroundColor : `#FFFFFF`};
    display: flex;
    flex: 1;
    padding: 5px 20px 15px 20px;
    height: ${() => (isPortrait() ? 355 : 220)}px;
    ${props =>
        props.sequenceFromDetailsCard
            ? `animation: ${ShrinkCardWrapper(
                  isPortrait() ? 355 : 220,
                  isPortrait() ? 310 : 175
              )} 300ms forwards;`
            : ``};
    position: relative;
    margin: ${props => (props.numActions === 2 && !isPortrait() ? `0 6px` : ``)};
    border-right: 1px solid #f1f1ee;
    box-shadow: 0 2px 4px 0 #e4e4e4;
    border-radius: 4px;
    border: solid 1px #dadad9;
    padding: ${props =>
        props.emailCard ? `15px 10px 10px` : isPortrait() ? `20px 15px 15px` : `15px`};
    ${props =>
        props.emailCard && !isPortrait() && props.numActions > 1
            ? `width: 49% !important;`
            : ''};

    &:focus {
        outline: none;
    }

    &:last-child {
        border-right: ${() => (widthEm() > 30 ? `0px` : ``)};
    }

    svg {
        height: 50px;
        width: 50px;
    }

    &:focus {
        outline: none;
    }

    &:last-child {
        border-right: ${() => (widthEm() > 30 ? `0px` : ``)};
    }

    svg {
        height: 50px;
        width: 50px;
    }

    button {
        width: calc(100% - 20px);
        margin: 0 auto;
        height: 45px;
        position: absolute;
        left: 10px;
        bottom: 10px;
        word-break: break-word;
        span {
            font-size: ${() => (isPortrait() ? 24 : 18)}px;
        }

        &:hover {
            background-color: #ff245e;
            border: solid 1px #ff245e;
            color: #fff;
        }

        &:hover span {
            color: #fff;
        }

        ${props =>
            widthEm() < 30 || props.isMultiDonation
                ? `
          bottom: 12px;
          left: 10px;
          padding: 0;
          width: calc(100% - 20px);
        `
                : ``};
    }
`;

const CardTitle = styled(Title)`
    ${() =>
        isPortrait()
            ? ``
            : `
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;`};
    margin: 10px 0;
    word-break: break-all;
    hyphens: auto;
`;

const CardHeader = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
`;

const TopRow = styled.div`
    height: 50px;
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-bottom: 5px;
`;
const DetailsRow = styled.div`
    display: flex;
    flex-direction: column;
`;

const OpportunityTitle = styled.h3`
    flex: 1;
    font-size: 15px;
    margin: 0;
    margin-left: 5px;
    word-break: break-letter;
    hyphens: auto;
`;

const ParentOrgName = styled(ParentOrg)`
    font-size: 11px;
    margin: 0;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
`;

const HeaderDetail = styled.h4`
    width: 95%;
    font-size: 10px;
    font-weight: 300;
    text-transform: uppercase;
    margin: 0;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    color: ${props => (props.isVirtual ? `#ff245e` : `#000000`)};
`;

const Description = styled.p`
    font-family: Lato;
    line-height: 1.33;
    color: #000;
    word-break: break-word;
    font-size: ${() => (isPortrait() ? 15 : 14)}px;
    overflow: hidden;
    margin: 5px 0;
    word-break: break-letter;
    hyphens: auto;

    span {
        font-weight: 800;
        color: #ff245e;
        cursor: pointer;
    }
`;

const SpinnerContainer = styled.div`
    width: 100%;
    display: flex;
    flex: 1;
    margin: 0 auto;
    justify-content: center;
    align-content: center;
    position: relative;
`;

const VolunteerCard = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    width: 100%;

    &.hide {
        display: none;
    }
`;

const PartnerImage = styled.img`
    width: auto !important;
    max-height: ${() => (isPortrait() ? 45 : 43)}px;
    max-width: 90px;
`;

const SubscribeFormWrapper = styled.div`
    height: 100%;
`;

class VolunteerDetails extends React.Component {
    constructor() {
        super();
        this.state = {
            nextActionVisibile: false,
            emailSignedUp: false,
            hover: false
        };
    }

    componentDidMount = () => {
        if (this.props.postalCode && !this.props.volunteerOpportunities) {
            this.loadVolunteerOpportunities();
        }
    };

    loadVolunteerOpportunities = () => {
        this.props.fetchVolunteerOpportunities(
            this.props.postalCode,
            this.props.countryCode,
            this.props.activeActionId,
            this.props.actionIdentifier,
            false, // preload screen
            false, // popup
            false // cache
        );
    };

    buildAddress = (s1 = '', s2 = '', city, state = '', zip = '') =>
        `${s1} ${s2} ${city ? city + ',' : ''} ${state} ${zip}`;

    render() {
        const carouselSettings = {
            arrows: this.props.actions.length > 2,
            centerMode: false,
            dots: false,
            draggabe: true,
            focusOnSelect: false,
            infinite: false,
            slidesToScroll: 1,
            slidesToShow: isPortrait() ? 1 : 1.5,
            speed: 500,
            swipeToSlide: true,
            preventFinalSlideAdvance: !isPortrait()
        };

        const sequenceFromDetailsCard =
            this.state.emailSignedUp &&
            this.props.actions.length === 1 &&
            this.props.hasNextAction;

        return (
            <Container
                onClick={() =>
                    this.props.onDetailsContainerClick(
                        this.props.actionIdentifier,
                        this.props.actionInitiated
                    )
                }
            >
                <Overlay />
                <OverlayPublisher />
                <OverlayPartner
                    logoIsSmall={false}
                    transitionType="right-to-left"
                    logo={volunteerMatchLogo}
                    name={'About Volunteer Match'}
                    description={
                        "We believe everyone should have the chance to make a difference. That's why we make it easy for good people and good causes to connect. We've connected millions of people with a great place to volunteer and helped tens of thousands of organizations better leverage volunteers to create real impact."
                    }
                />
                <VolunteerBody>
                    <WidgetHeader />
                    <CardTitle
                        scaleFactor={isPortrait() ? 0.666 : 0.8}
                        isLongText={isLongText(this.props.headerText, 60)}
                        isExtraLongText={isLongText(this.props.headerText, 90)}
                        onClick={e => {
                            e.preventDefault();
                            this.props.setOverlayPartnerVisible(true, e, false);
                        }}
                        dangerouslySetInnerHTML={{
                            __html: this.props.headerText
                        }}
                    />
                    {this.props.isVolunteerOpportunitiiesLoading ? (
                        <SpinnerContainer>
                            <LoadingSpinner
                                position={'center'}
                                width={80}
                                height={80}
                                stroke={6}
                                color={'#ff245e'}
                            />
                        </SpinnerContainer>
                    ) : (
                        <Carousel
                            carouselSettings={carouselSettings}
                            className={() => (isPortrait() ? 'carousel-mobile' : '')}
                            hover={this.state.hover}
                            isVolunteer={true}
                            numActions={this.props.actions.length}
                            onMouseEnter={() => this.setState({ hover: true })}
                            onMouseLeave={() => this.setState({ hover: false })}
                            showSlider={isPortrait() || this.props.actions.length > 1}
                        >
                            {this.props.actions.map((a, i) => {
                                if (a.id === 'signup') {
                                    return (
                                        <VolunteerCardWrapper
                                            sequenceFromDetailsCard={
                                                sequenceFromDetailsCard
                                            }
                                            emailCard={true}
                                            numActions={this.props.actions.length}
                                            isMultiDonation={false}
                                            key={a.id}
                                        >
                                            <SubscribeFormWrapper
                                                numActions={this.props.actions.length}
                                            >
                                                <VolunteerSubscribeForm
                                                    onShowLocationChangePopup={
                                                        this.props
                                                            .onShowLocationChangePopup
                                                    }
                                                    actionIdentifier={
                                                        this.props.actionIdentifier
                                                    }
                                                    numActions={this.props.actions.length}
                                                    onSubmit={values => {
                                                        this.props.cacheFormData(values);
                                                        this.props.onSubscribeComplete(
                                                            values,
                                                            this.props.activeAction.type,
                                                            null,
                                                            null,
                                                            false,
                                                            () => {
                                                                this.setState({
                                                                    emailSignedUp: true
                                                                });
                                                                setTimeout(
                                                                    () =>
                                                                        this.setState({
                                                                            nextActionVisibile: true
                                                                        }),
                                                                    500
                                                                );
                                                            }
                                                        );
                                                    }}
                                                    volunteerForm={true}
                                                    isEmailSubmitting={
                                                        this.props.isEmailSubmitting
                                                    }
                                                    isEmailSubmitted={
                                                        this.state.emailSignedUp
                                                    }
                                                />
                                            </SubscribeFormWrapper>
                                        </VolunteerCardWrapper>
                                    );
                                } else {
                                    return (
                                        <VolunteerCardWrapper
                                            numActions={this.props.actions.length}
                                            isMultiDonation={false}
                                            key={a.id}
                                        >
                                            <VolunteerCard>
                                                <CardHeader>
                                                    <TopRow>
                                                        {a.imageUrl ? (
                                                            <PartnerImage
                                                                src={decodeURIComponent(
                                                                    a.imageUrl
                                                                ).replace(
                                                                    /https/g,
                                                                    'http'
                                                                )}
                                                            />
                                                        ) : (
                                                            <DefaultVolunteerImage
                                                                issueId={
                                                                    this.props
                                                                        .associatedOpportunityIssueId
                                                                }
                                                            />
                                                        )}
                                                        <OpportunityTitle>
                                                            {truncateOpportunityTitle(
                                                                normalizeOpportunityName(
                                                                    a.title
                                                                ),
                                                                isPortrait()
                                                            )}
                                                        </OpportunityTitle>
                                                    </TopRow>
                                                    <DetailsRow>
                                                        <ParentOrgName>
                                                            {a.parentOrg.name}
                                                        </ParentOrgName>
                                                        <HeaderDetail
                                                            isVirtual={a.virtual}
                                                        >
                                                            {a.virtual
                                                                ? 'VIRTUAL'
                                                                : this.buildAddress(
                                                                      a.address.street1,
                                                                      a.address.street2,
                                                                      a.address.city,
                                                                      a.address.state,
                                                                      a.address.zipCode
                                                                  )}
                                                        </HeaderDetail>
                                                    </DetailsRow>
                                                </CardHeader>
                                                <Description
                                                    dangerouslySetInnerHTML={{
                                                        __html: truncateOpportunityDescription(
                                                            a.description,
                                                            this.props.actions.length,
                                                            isPortrait()
                                                        )
                                                    }}
                                                    onClick={e =>
                                                        this.props.setOverlayPartnerVisible(
                                                            true,
                                                            e,
                                                            false
                                                        )
                                                    }
                                                />
                                                <MultiActionsCardAction
                                                    action={a}
                                                    isMultiDonation={false}
                                                    tweetContent={a.text || ''}
                                                    key={a.identifier}
                                                    label={'SELECT'}
                                                    showTwitterPopUp={false}
                                                    localRepFound={false}
                                                    partnerName={a.partnerName}
                                                    onClick={() =>
                                                        this.props.onSelectVolunteerOpportunity(
                                                            i,
                                                            this.props.actions
                                                        )
                                                    }
                                                />
                                            </VolunteerCard>
                                        </VolunteerCardWrapper>
                                    );
                                }
                            })}
                        </Carousel>
                    )}
                    <TransitionGroup>
                        {this.props.postalCodeFormPopupIsVisible && (
                            <CssTransition
                                key="alert"
                                in={this.props.postalCodeFormPopupIsVisible}
                            >
                                <LocationChangePopup
                                    onBack={() => {
                                        this.props.onShowLocationChangePopup(
                                            false,
                                            this.props.actionIdentifier,
                                            this.props.actionInitiated
                                        );
                                    }}
                                />
                            </CssTransition>
                        )}
                    </TransitionGroup>
                    {sequenceFromDetailsCard && this.state.nextActionVisibile && (
                        <NextAction />
                    )}
                    <Footer>
                        <ShareDrawer
                            fullwidth={true}
                            backgroundColor={sequenceFromDetailsCard ? null : '#ffffff'}
                        >
                            <ChangeLocationLink
                                onClick={() =>
                                    this.props.onShowLocationChangePopup(
                                        true,
                                        this.props.actionIdentifier,
                                        this.props.actionInitiated
                                    )
                                }
                            >
                                {isPortrait()
                                    ? 'Change Location'
                                    : 'Interested in volunteering somewhere else?'}
                            </ChangeLocationLink>
                        </ShareDrawer>
                        <PBVMFooter
                            sequenceFromDetailsCard={sequenceFromDetailsCard}
                            onClick={e =>
                                this.props.setOverlayPartnerVisible(true, e, true)
                            }
                        >
                            {'Powered by VolunteerMatch'}
                        </PBVMFooter>
                    </Footer>
                </VolunteerBody>
            </Container>
        );
    }
}

VolunteerDetails.propTypes = {
    actionIdentifier: PropTypes.string.isRequired,
    activeActionId: PropTypes.number.isRequired,
    activeAction: PropTypes.object.isRequired,
    actionInitiated: PropTypes.bool.isRequired,
    associatedOpportunityIssueId: PropTypes.number,
    postalCode: PropTypes.string,
    countryCode: PropTypes.string,
    actions: PropTypes.array.isRequired,
    headerText: PropTypes.string.isRequired,
    volunteerOpportunities: PropTypes.array,
    hasNextAction: PropTypes.bool.isRequired,
    isVolunteerOpportunitiiesLoading: PropTypes.bool,
    isEmailSubmitting: PropTypes.bool,
    isEmailSubmitted: PropTypes.bool,
    onSelectVolunteerOpportunity: PropTypes.func.isRequired,
    onSubscribeComplete: PropTypes.func.isRequired,
    onShowLocationChangePopup: PropTypes.func.isRequired,
    postalCodeFormPopupIsVisible: PropTypes.bool.isRequired,
    setOverlayPartnerVisible: PropTypes.func.isRequired,
    onDetailsContainerClick: PropTypes.func.isRequired,
    fetchVolunteerOpportunities: PropTypes.func.isRequired,
    cacheFormData: PropTypes.func.isRequired
};

export default connect(
    state => {
        const SignUpSlideData = { id: 'signup' };
        return {
            actionInitiated: state.volunteer.actionInitiated,
            activeAction: state.widget.activeAction,
            actionIdentifier: state.widget.activeAction.identifier,
            associatedOpportunityIssueId: state.widget.activeAction.issue.id,
            postalCode: state.widget.endUserLocation
                ? state.widget.endUserLocation.postalCode
                : undefined,
            countryCode: state.widget.endUserLocation
                ? state.widget.endUserLocation.countryCode
                : 'US',
            hasNextAction: !!getNextAction(
                state.widget.actions,
                state.widget.activeAction.identifier,
                buildConditionalActionsAnswerHistory(state),
                state.widget.cards
            ),
            isMobileResolution: state.widget.isMobileResolution,
            isMultiActionsCard:
                state.widget.cards[state.widget.activeAction.order - 1].type ===
                CardTypes.multipleActions,
            isEmailSubmitting: state.widget.isEmailSubmitting,
            isEmailSubmitted: state.widget.isEmailSubmitted,
            activeActionId: state.widget.activeAction.id,
            actions: (state.volunteer.volunteerOpportunities || [])
                .map(a => ({ ...a }))
                .concat(SignUpSlideData),
            endUserLocation: state.widget.endUserLocation,
            headerText: truncateTitle(
                (
                    state.widget.cards[state.widget.activeAction.order - 1].heading ||
                    'Volunteer in your community today!'
                ).replace(
                    new RegExp(Placeholders.LocalePlaceholder, 'g'),
                    replaceLocale(state)
                )
            ),
            isVolunteerOpportunitiiesLoading:
                state.volunteer.isVolunteerOpportunitiiesLoading,
            postalCodeFormPopupIsVisible: state.volunteer.postalCodeFormPopupIsVisible,
            volunteerOpportunities: state.volunteer.volunteerOpportunities
        };
    },
    {
        fetchVolunteerOpportunities,
        getApiRequestData,
        onGoToNextActionInsideCard,
        onGoToStep,
        onSelectVolunteerOpportunity,
        onShowLocationChangePopup,
        setOverlayPartnerVisible,
        onDetailsContainerClick,
        onSubscribeComplete,
        cacheFormData
    }
)(VolunteerDetails);



// WEBPACK FOOTER //
// ./src/containers/Volunteer/VolunteerDetails.jsx